module.exports = __webpack_public_path__ + "Lato-Medium.ttf?863b7dcd5ec2c3923122af25ce0f7e4c";